import { h } from "vue";
import type { FunctionalComponent, HTMLAttributes, VNodeProps } from "vue";

type SvgIconProps = HTMLAttributes &
  VNodeProps & {
    size?: number | string;
  };

export function createSvgIcon(svg: string): FunctionalComponent<SvgIconProps> {
  const document = new DOMParser().parseFromString(svg, "image/svg+xml");
  const svgElement = document.documentElement;

  const attributes = Object.fromEntries(
    Array.from(svgElement.attributes).map((attribute) => [
      attribute.name,
      attribute.value,
    ]),
  );

  const Icon: FunctionalComponent<SvgIconProps> = (props) => {
    const { size, ...restProps } = props;

    return h(svgElement.tagName, {
      ...attributes,
      ...restProps,
      width:
        typeof size === "number" ? `${size}px` : (size ?? attributes.width),
      height:
        typeof size === "number" ? `${size}px` : (size ?? attributes.height),
      innerHTML: svgElement.innerHTML,
    });
  };

  Icon.displayName = "CustomSvgIcon";

  return Icon;
}
